<template>
  <div>
    <div class="center-t">
      <div class="sp-odt">经济指标数据管理</div>
    </div>
    <div class="page-wrap">
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="mini"
        style="margin-bottom:20px"
        @click="handleAdd"
      >添加</el-button>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" width="55" label="序号" align="center">
          <template slot-scope="scope">
            {{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="annualYear"
          label="年度"
          width="120"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="annualRevenue"
          label="年营业收入(万元)"
          align="center"
          width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="annualProfit"
          label="年利润(万元)"
          width="120"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="researchInvestment"
          label="科研投入(万元)"
          width="120"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="iprInvestment"
          label="知识产权投入(万元)"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row.id)"
            >更新</el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
    <econDialog
      :econ_dialogVisible.sync="econ_dialogVisible"
      v-if="econ_dialogVisible"
      :id="id"
      @refresh="getList"
    ></econDialog>
  </div>
</template>
<script>
import { econList, econDelete } from "@/api/index";
import econDialog from "@/views/userpage/components/econDialog";
export default {
  components: { econDialog },
  data() {
    return {
      queryParams: {
        pageSize: 10,
        pageNum: 1
      },
      tableData: [],
      id: "",
      total: 0,
      econ_dialogVisible: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      econList({ ...this.queryParams }).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    handleEdit(id) {
      this.id = id;
      this.econ_dialogVisible = true;
    },
    handleAdd() {
      this.id = "";
      this.econ_dialogVisible = true;
    },
    handleDelete(id) {
      this.$confirm("是否确认删除该数据？", "提示", {
        confirmButtonText: "确定删除",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          econDelete([id]).then(res => {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getList();
          });
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
</style>